import React from "react";
import { Formik } from "formik";
import { DialogContent, Grid, Drawer } from "@mui/material";
import Actions from "./Actions";

export default function ActionDrawer({
  actions,
  openDrawer,
  setOpenDrawer,
  formikProps,
  setNewAction,
}) {
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDrawer({ [anchor]: open, data: {}, id: "" });
  };

  return (
    <Drawer
      PaperProps={{
        sx: { width: "60%" },
      }}
      anchor={"right"}
      open={openDrawer.state}
      onClose={toggleDrawer("right", false)}
    >
      <Formik
        enableReinitialize
        initialValues={openDrawer.data}
        validateOnChange
      >
        {(dialogFormikProps) => (
          <DialogContent>
            <Grid container spacing={4}>
              <Actions
                openDrawer={openDrawer}
                setNewAction={setNewAction}
                actions={actions}
                parentFormik={formikProps}
                setOpenDrawer={setOpenDrawer}
                formikProps={formikProps}
              />
            </Grid>
          </DialogContent>
        )}
      </Formik>
    </Drawer>
  );
}
